import React, { useEffect } from 'react';
import styles from './GDPR.module.css';
import Separator from '../../components/Separator';
import gdprJson from '../../assets/data/gdpr.json';
import CollapsablePanel from '../../components/CollapsablePanel/CollapsablePanel';
import { useTranslation } from 'react-i18next';

const GDPR = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = 'GDPR In-Depth - The Records Hub S.A.';
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.titleContainer}>
                <div className={styles.title}>
                    {t('gdpr.title')}
                    <Separator widht={'30px'} height={'1px'} color={'#f7931d'} />
                </div>
            </div>
            <div className={styles.sessionContainer} style={{ backgroundColor: '#FEFCFC' }}>
                <p className={styles.sessionTitle}>{t('gdpr.session0.title')}</p>
                <p className={styles.sessionContent}>
                    {t('gdpr.session0.description')}
                </p>
            </div>
            <div className={styles.sessionContainer}>
                <p className={styles.sessionTitle}>{t('gdpr.session1.title')}</p>
                <p className={styles.sessionContent}>
                    {t('gdpr.session1.description')}
                </p>
            </div>
            <p className={styles.gdprServicesTitlte}>
                {t('gdpr.servicesTitle')}
            </p>
            {gdprJson &&
                gdprJson.map((item, i) => (
                    <div
                        className={styles.bannerContainer}
                        style={{ backgroundColor: !(i % 2) ? '#FCFCFC' : '' }}
                        key={`banner${i}`}
                    >
                        <h3 className={styles.bannerTitle}>{item.title[i18n.language]}</h3>
                        <div className={styles.rightBannerContainer}>
                            {item.items &&
                                item.items.map((elem, j) => (
                                    <CollapsablePanel
                                        title={elem.title[i18n.language]}
                                        data={elem.content[i18n.language]}
                                        key={`panel${j}`}
                                    />
                                ))}
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default GDPR;
